import React, { useState, useEffect,useContext } from "react";
import axiosInstance from "../../ReusableComponents/Axios";
import DataTable from "../../Student/Reusablecomponents/DataTable/DataTable";
import { Languages } from "../../ReusableComponents/CommonFunctions";
import { useSelector, useDispatch } from "react-redux";
import { SelectLanguageData } from "../../Redux/Reducers/Common/Language";
import SubHeadersDataTable from "../../Student/Reusablecomponents/DataTable/SubHeadersDataTable";
import DropdownValues from "../../Student/Reusablecomponents/DropDownValues";
import InternetChecking from "../../Student/Reusablecomponents/Network";
import {GetLanguagename} from "../../ReusableComponents/QBAdmin/QBAFunctions";
import {LoadContext} from "../../ReusableComponents/LoadingContex";
const TranslationCounts = () => {
    const dispatch = useDispatch();
    const {SetLoad} = useContext(LoadContext);
    const [QCounts, SetQCounts] = useState([]);
    const [QSCounts, SetQSCounts] = useState([]);
    const [SGrade, SetSGrade] = useState(6);
      const SelectLanguage = useSelector((state) => state.SelectLanguageData.SLanguage);
    useEffect(() => {
        GetQCounts();
        // GetQCountStatus();
    }, [SelectLanguage])
    const GetQCounts = async () => {
        SetLoad(true);
        try {
            const res = await axiosInstance.get(`/NCLAdmin/GetQTCountSBasedonSubjectandGrade?LanguageId=${SelectLanguage}`);
            SetQCounts(res.data);
            GetQCountStatus();
        }
        catch (err) { console.log(err);GetQCountStatus(); }
    }
    const GetQCountStatus = async (G) => {
        try {
            const res = await axiosInstance.get(`/NCLAdmin/GetQCountsByVerificationStatusAndGrade?Grade=${G || SGrade}&LanguageId=${SelectLanguage}`);
            SetQSCounts(res.data);
            SetLoad(false);
        }
        catch (err) { console.log(err) }
    }
    const QCountcolumns = [
        { name: "Grade", selector: "grade", sortable: true },
        {
            name: "Mathematics",
            subColumns: [
                { name: "Total Questions", selector: "totalMathsQs", sortable: true },
                { name: "Total Translated Questions", selector: "totalMathsTranslatedQs", sortable: true },
                { name: "Total translated Completed Questions", selector: "totalMathsTranslatedQCs", sortable: true },
            ],
        },
        {
            name: "Science",
            subColumns: [
                { name: "Total Questions", selector: "totalScienceQs", sortable: true },
                { name: "Total Translated Questions", selector: "totalScienceTranslatedQs", sortable: true },
                { name: "Total translated Completed Questions", selector: "totalScienceTranslatedQCs", sortable: true },
            ],
        },

    ];
    const QSCountcolumns = [
        { name: "Subject Name", selector: "subjectName", sortable: true },
        { name: "Total Questions", selector: "totalQuestions", sortable: true },
        { name: "Authoring", selector: "authoring", sortable: true },
        { name: "Verify", selector: "verify", sortable: true },
        { name: "Correction", selector: "correction", sortable: true },
        { name: "Re-Verify", selector: "reVerify", sortable: true },
        { name: "Completed", selector: "completed", sortable: true },
        { name: "Total Translated Questions", cell:(row)=>(row?.authoring + row?.verify + row?.correction + row?.reVerify + row?.completed ) },
    ];
    const Grades = [{ display: "Pre-primary", value: "Pre-primary" }, { display: "Grade 1", value: 1 }, { display: "Grade 2", value: 2 },{ display: "Grade 3", value: 3 }, { display: "Grade 4", value: 4 }, { display: "Grade 5", value: 5 },{ display: "Grade 6", value: 6 }, { display: "Grade 7", value: 7 }, { display: "Grade 8", value: 8 },
    { display: "Grade 9", value: 9 }, { display: "Grade 10", value: 10 }, { display: "Grade 11", value: 11 }, { display: "Grade 12", value: 12 }]
    return (
        <>
            <div className="TeacherBgImage">
                <InternetChecking />
                <div className="MainHeading">Translation QC Dashboard</div>
                <div className="dflex alignitems JSBetween">
                    <div className="SubHeading"> Subject-wise {GetLanguagename(SelectLanguage)?.[1]} Questions count of total translation and total QC </div>
                    <Languages Telugu="English" onChange={(e) => { dispatch(SelectLanguageData({ SLanguage: e })); }} />
                </div>
                <SubHeadersDataTable className="Card NCLDataTable mt-2" data={QCounts} columns={QCountcolumns} Dropdownvalues={[25]} />

                <div className="dflex alignitems JSBetween mt-3">
                    <div className="SubHeading"> Question Verification Status for Translation </div>
                    <DropdownValues options={Grades} className="NCLDropdown" onChange={(e)=>{SetLoad(true);SetSGrade(e.target.value);GetQCountStatus(e.target.value)}} selectoption={SGrade} />
                </div>
                <DataTable className="Card NCLDataTable mt-2" data={QSCounts} columns={QSCountcolumns} />
            </div>
        </>
    )
}
export default TranslationCounts;